import { useRef, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Mail } from 'lucide-react';
import { toast } from 'sonner';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export default function ForgotPasswordPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submitLockRef = useRef(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (isSubmitting || submitLockRef.current) return;
    submitLockRef.current = true;

    if (!email) {
      toast.error('Lütfen e-posta adresinizi girin');
      submitLockRef.current = false;
      return;
    }

    try {
      setIsSubmitting(true);
      const resp = await fetch(`${API_BASE_URL}/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      if (!resp.ok) {
        let detail = 'İşlem başarısız';
        try {
          const err = await resp.json();
          detail = err?.detail || err?.message || detail;
        } catch (e2) {
          // ignore
        }
        toast.error(detail);
        return;
      }

      toast.success('Eğer bu e-posta kayıtlıysa şifre sıfırlama bağlantısı gönderilecektir.');
      navigate('/giris');
    } catch (err) {
      toast.error('İşlem başarısız');
    } finally {
      setIsSubmitting(false);
      submitLockRef.current = false;
    }
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4" data-testid="forgot-password-page">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-2xl shadow-lg p-8">
          <div className="text-center mb-8">
            <Link to="/" className="inline-block">
              <h1 className="font-manrope font-bold text-3xl text-trendyol-orange">Alışveriş Burada</h1>
            </Link>
            <p className="text-gray-600 mt-2">Şifrenizi sıfırlayın</p>
          </div>

          <form onSubmit={handleSubmit} className="space-y-5">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">E-posta</label>
              <div className="relative">
                <input
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="w-full px-4 py-3 border-2 border-gray-200 rounded-lg focus:border-trendyol-orange focus:outline-none transition-colors pl-11"
                  placeholder="ornek@email.com"
                />
                <Mail className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 text-gray-400" />
              </div>
            </div>

            <button
              type="submit"
              disabled={isSubmitting}
              className="w-full bg-trendyol-orange hover:bg-orange-600 text-white font-semibold py-3 rounded-lg transition-colors"
            >
              Sıfırlama Bağlantısı Gönder
            </button>
          </form>

          <div className="mt-6 text-center">
            <Link to="/giris" className="text-sm text-trendyol-orange hover:underline">
              Giriş sayfasına dön
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
